import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
export var RatingFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});